/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getImageFile, fallbackImage } from 'utils/stringUtils';
import StyledLink from 'components/StyledLink';
import Title from './Title';
import ViewLink from '../ViewLink';
import NavBarContext from '../../navBarContext';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: '#F8F9F9',
    padding: '17px 26px 43px 17px',
    [theme.breakpoints.down('xs')]: {
      padding: '17px 20px',
    },
  },
  header: {
    marginBottom: 16,
  },
  lists: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  image: {
    width: 107,
    height: 60,
    marginRight: 15,
    objectFit: 'cover',
  },
  listItem: {
    width: 236,
    marginBottom: 10,
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}));

function MostPopular({ data, isNews, clickHandler }) {
  const classes = useStyles();
  const { siteCopy } = useContext(NavBarContext);
  if (!data) return null;
  const linkLabel = _get(siteCopy, [
    'pageCopy',
    isNews ? 'submenu-news' : 'submenu-blogs',
    'view-all',
  ]);
  const link = isNews ? '/news' : '/insights';
  return (
    <div className={classes.root} data-test-id="menu-news-popular">
      <Typography className={classes.header} color="textPrimary">
        {_get(siteCopy, [
          'pageCopy',
          isNews ? 'submenu-news' : 'submenu-blogs',
          'most-popular',
        ])}
      </Typography>
      <div className={classes.lists} data-test-id="popular-list">
        {data.slice(0, 5).map(el => {
          const imageSrc = getImageFile(el);
          const { slug, name } = el;
          return (
            <StyledLink
              link={`${isNews ? '/articles' : '/insights'}/${slug}`}
              key={slug}
            >
              <div className={classes.listItem}>
                <div>
                  <img
                    onClick={() => clickHandler(name, 'image')}
                    src={imageSrc}
                    alt={name}
                    className={classes.image}
                    onError={e => {
                      e.target.src = fallbackImage;
                    }}
                  />
                </div>
                <Title
                  title={name}
                  onClick={() => clickHandler(name, 'text')}
                />
              </div>
            </StyledLink>
          );
        })}
      </div>
      <ViewLink label={linkLabel} link={link} />
    </div>
  );
}

MostPopular.propTypes = {
  data: PropTypes.array,
  isNews: PropTypes.bool,
  clickHandler: PropTypes.func,
};

export default MostPopular;
